import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';

const noop = () => {};

type Props = {
  value?: string | undefined;
  onChange?: (event) => any;
  onBlur?: (event) => any;
  onMouseLeave?: (event) => any;
  onFocus?: (event) => any;
  onKeyDown?: (event) => any;
  inputRef?: (ref: HTMLTextAreaElement) => any;
  disabled?: boolean;
  placeholder?: string;
  style?: { [key: string]: any };
  className?: string;
  maxLength?: number;
  name?: string;
  [key: string]: any;
};

class Textarea extends React.Component<Props, {}> {
  inputRef?: HTMLTextAreaElement | null = null;

  static defaultProps = {
    onBlur: noop,
    onFocus: noop,
    onKeyDown: noop,
    inputRef: noop,
    disabled: false,
    placeholder: '',
    style: {},
    className: '',
  };

  proxyRef = (node: HTMLTextAreaElement) => {
    if (!node) return;

    const { inputRef, onKeyDown } = this.props;

    if (onKeyDown) {
      node.addEventListener('keydown', onKeyDown);
    }

    this.inputRef = node;

    if (inputRef) {
      inputRef(node);
    }
  };

  render() {
    const {
      value,
      onChange,
      onFocus,
      onBlur,
      disabled,
      placeholder,
      style,
      className,
      maxLength,
      name,
      onMouseLeave,
    } = this.props;

    return (
      <TextareaAutosize
        placeholder={placeholder}
        disabled={disabled}
        style={style}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onMouseLeave={onMouseLeave}
        inputRef={this.proxyRef}
        className={className}
        maxLength={maxLength}
        name={name}
      />
    );
  }
}

export default Textarea;
